<style lang="scss" scoped>
.sitemap {
  background-color: #fff;
  height: 100%;
  text-align: left;
  overflow-y: scroll !important;
}
</style>
<template>
  <div class="sitemap">
    Sitemap
    <!-- <p v-for="art in artLinks">
      {{ art }}
    </p>
    <p v-for="story in storyLinks">
      {{ story }}
    </p>
    <p v-for="link in storyWithArtLinks">
      {{ link }}
    </p>
    <p v-for="link in artWithStories">
      {{ link }}
    </p>
    <p v-for="link in categoryLinks">
      {{ link }}
    </p>
    <p v-for="link in yearLinks">
      {{ link }}
    </p> -->
  </div>
</template>

<script>
import { tags } from '@/utils/tags';
export default {
  name: 'Sitemap',
  components: {
   
  },
  data() {
    return {
      artWork: null,
      stories: null,
      tags: tags,
      years: [],
    };
  },
  computed: {
    API() {
      return this.$API;
    },
    // artLinks() {
    //   if (this.artWork) {
    //     let links = [];
    //     this.artWork.forEach((a) => {
    //       links.push(`artstory.net/art/${a.link}`);
    //     });
    //     return links;
    //   }
    //   return [];
    // },
    // storyLinks() {
    //   if (this.stories) {
    //     let links = [];
    //     this.stories.forEach((s) => {
    //       links.push(`artstory.net/story/${s.link}`);
    //     });
    //     return links;
    //   }
    //   return [];
    // },
    // storyWithArtLinks() {
    //   if (this.artWork && this.stories) {
    //     let links = [];
    //     this.stories.forEach((s) => {
    //       this.artWork.forEach((a) => {
    //         links.push(`artstory.net/story/${s.link}/art/${a.link}`);
    //       });
    //     });
    //     return links;
    //   }
    //   return [];
    // },
    // artWithStories() {
    //   if (this.artWork && this.stories) {
    //     let links = [];
    //     this.artWork.forEach((a) => {
    //       this.stories.forEach((s) => {
    //         links.push(`artstory.net/art/${a.link}/story/${s.link}`);
    //       });
    //     });
    //     return links;
    //   }
    //   return [];
    // },
    // categoryLinks() {
    //   if (this.tags) {
    //     let links = [];
    //     this.tags.forEach((tag) => {
    //       links.push(`artstory.net/category/${tag}`);
    //     });
    //     return links;
    //   }
    //   return []; 
    // },
    // yearLinks() {
    //   if (this.years) {
    //     let links = [];
    //     this.years.forEach((year) => {
    //       links.push(`artstory.net/year/${year}`);
    //     });
    //     return links;
    //   }
    //   return [];  
    // },
  },
  created() {
    this.getArt();
    this.getStories();
  },
  methods: {
    getArt() {
      this.axios.get(`${this.$API}/arts-stripped?_sort=title:ASC&_limit=-1`).then((response) => {
        this.artWork = response.data;
        // this.updateYears(this.artwork);
      });
    },
    getStories() {
      this.axios.get(`${this.$API}/stories-stripped?_sort=date:ASC`).then((response) => {
        this.stories = response.data;
        this.storyWithArtLinks();

        // this.updateYears(this.stories);
      });
    },
    updateYears(items) {
      const tempYears = {};
      items.forEach((item) => {
        const year = new Date(item.date).getFullYear();
        tempYears[year] = year;
      });
      this.years = this.years.concat(Object.keys(tempYears))
        .filter((year, index, self) => self.indexOf(year) === index)
        .sort()
        .reverse();
    },

    artLinks() {
      if (this.artWork) {
        this.artWork.forEach((a) => {
          console.log(`artstory.net/art/${a.link}`);
        });
      }
    },
    storyLinks() {
      if (this.stories) {
        this.stories.forEach((s) => {
          console.log(`artstory.net/story/${s.link}`);
        });
      }
    },
    storyWithArtLinks() {
      if (this.artWork && this.stories) {
        this.stories.forEach((s) => {
          this.artWork.forEach((a) => {
            console.log(`artstory.net/story/${s.link}/art/${a.link}`);
          });
        });
      }
    },
    artWithStoriesLinks() {
      if (this.artWork && this.stories) {
        this.artWork.forEach((a) => {
          this.stories.forEach((s) => {
            console.log(`artstory.net/art/${a.link}/story/${s.link}`);
          });
        });
      }
    },
    categoryLinks() {
      if (this.tags) {
        this.tags.forEach((tag) => {
          console.log(`artstory.net/category/${tag}`);
        });
      }
    },
    yearLinks() {
      if (this.years) {
        this.years.forEach((year) => {
          console.log(`artstory.net/year/${year}`);
        });
      }
    },
  },
};
</script>
